import TitleHeader from '../../atoms/TitleHeader/TitleHeader'
import { motion } from "framer-motion";

import rightarrow from '../../../assets/images/aboutuspage/rightarrow.webp'
import leftarrow from '../../../assets/images/aboutuspage/leftarrow.webp'
import handandbar from '../../../assets/images/aboutuspage/hand_bar_bg.webp'
import AboutUs2 from '../../../assets/images/aboutuspage/storayimage2.webp'
import exclamationMark from '../../../assets/images/aboutuspage/exclamation_mark.webp'

type AboutUsHighlightSectionProps = {
  leftImageSrc: string
  rightImageSrc: string
  leftImageAlt?: string
  rightImageAlt?: string
  heading: string
  paragraphLead: string
  paragraphRest: string
  paragraphResttwo: string
}

const AboutUsHighlightSection = ({
  leftImageAlt = '',
  rightImageAlt = '',
  paragraphLead,
  paragraphRest,
  paragraphResttwo,
}: AboutUsHighlightSectionProps) => {
  return (
    <section className="w-full md:py-16 md:px-10">

      {/* HEADER */}
      <div className="flex items-center justify-center">
        <TitleHeader
          badgeText="OUR STORY"
          titleLines={['From Technical Excellence to Trusted Partnership']}
          wrapperClassName="w-full max-w-4xl flex flex-col items-center text-center"
          titleClassName="text-4xl  md:text-4xl font-rajdhani font-semibold text-center w-[90%]"
          badgeClassName="text-xl md:text-2xl px-8 md:px-10 py-2.5 md:py-3.5"
        />
      </div>

      {/* CONTENT */}
      <div className="mx-auto lg:max-w-[90%] xl:max-w-[80%] flex flex-col lg:flex-row items-center md:gap-10 lg:gap-16">

        {/* 🖼️ IMAGE SECTION */}
        <motion.div
          className="w-full lg:w-[50%] flex justify-center lg:justify-start"
          initial={{ opacity: 0, x: -90 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.6 }}
          transition={{ duration: 2.2, ease: [0.22, 1, 0.36, 1] }}
        >
          <div className="relative mt-5 w-[180px] sm:w-[180px] md:w-[350px] lg:w-[520px]">

            {/* BASE IMAGE */}
            <img
              src={handandbar}
              alt="visual"
              className="w-full h-auto object-contain"
            />

            {/* ⬅️ LEFT ARROW */}
            <motion.img
              src={leftarrow}
              alt="left arrow"
              className="absolute left-[20%] md:left-[17%] lg:left-[18%] xl:left-[20%] top-[32%] w-[40px] md:w-[70px] lg:w-[80px] xl:w-[100px]"
              animate={{
                x: [0, -25, 0],
                scale: [1, 1.1, 1],
              }}
              transition={{
                duration: 2,
                repeat: Infinity,
                ease: "easeInOut",
              }}
             
            />

            {/* ➡️ RIGHT ARROW */}
            <motion.img
              src={rightarrow}
              alt="right arrow"
              className="absolute right-[22%] top-[32%] w-[45px] md:w-[80px] sm:w-[80px] xl:w-[100px]"
              animate={{
                x: [0, 25, 0],
                scale: [1, 1.1, 1],
              }}
              transition={{
                duration: 2,
                repeat: Infinity,
                ease: "easeInOut",
                delay: 0.2,
              }}
            
            />

            {/* 🔄 ROTATING CIRCLE */}
            {/* 🔄 ROTATING CIRCLE + ❗ EXCLAMATION */}
<div
  className="
    hidden sm:block
    absolute 
    bottom-0 right-0
    translate-x-1/3 translate-y-[20%]
    w-[120px] sm:w-[160px] md:w-[220px] lg:w-[260px]
  "
>
  {/* ROTATING IMAGE */}
  <motion.img
    src={AboutUs2}
    alt={rightImageAlt}
    className="w-full h-full object-contain"
    animate={{ rotate: -360 }}
    transition={{
      repeat: Infinity,
      duration: 25,
      ease: "linear",
    }}
  />

  {/* CENTERED EXCLAMATION */}
  <img
    src={exclamationMark}
    alt="exclamation mark"
    className="
      absolute top-1/2 left-1/2 
      -translate-x-1/2 -translate-y-1/2
      w-[25px] sm:w-[35px] md:w-[45px] lg:w-[55px]
      z-30 pointer-events-none
    "
  />
</div>

       

          </div>
        </motion.div>

        {/* 📝 TEXT SECTION */}
        <motion.div
          className="w-full px-4 lg:flex-1 flex flex-col justify-center text-center lg:text-left"
          initial={{ opacity: 0, scale: 0.75 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, amount: 0.6 }}
          transition={{ duration: 2.2, ease: [0.22, 1, 0.36, 1], delay: 0.25 }}
        >

          <p className="mt-4 md:mt-6 font-gilroy w-full text-base md:text-lg lg:text-2xl leading-relaxed text-gray-400">
            <span className="font-semibold text-white">{paragraphLead}</span>{' '}
            {paragraphRest}
          </p>

          <p className="mt-4 md:mt-6 font-gilroy w-full text-base md:text-lg lg:text-2xl leading-relaxed text-gray-400">
            {paragraphResttwo}
          </p>

        </motion.div>

      </div>
    </section>
  )
}

export default AboutUsHighlightSection
